import React from 'react';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import { Helmet } from 'react-helmet';
import data from '../data/paomakeup';
import { BUSINESS, ROUTES } from '../data/pmContent';
import { IconArrow, IconPin, IconClock, IconParking } from '../components/pm/PmIcons';

const AboutUs = () => {
  return (
    <div className="pm-scope page">
      <Helmet>
        <title>Conoce nuestra empresa - {data.title}</title>
        <meta name="description" content="Somos un equipo de profesionales enfocados en la belleza. Hemos creado este centro ofreciendo la mejor asistencia en el área de maquillaje, peinados y otros servicios que demanda la mujer de hoy en día." />
        <meta name="keywords" content={data.our_services_price_keywords} />
        <meta property="og:title" content="Conoce nuestra empresa" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="/nosotros" />
        <meta property="og:site_name" content="PaoMakeup Beauty Studio" />
        <meta property="og:description" content="Somos un equipo de profesionales enfocados en la belleza. Hemos creado este centro ofreciendo la mejor asistencia en el área de maquillaje, peinados y otros servicios que demanda la mujer de hoy en día." />
      </Helmet>

      <section className="section">
        <div className="container">
          <div className="about__grid">
            <div className="about__media">
              <img
                src={`/${data.aboutus_image}`}
                alt={`Paola Muñoz, fundadora de ${BUSINESS.name}`}
                width="800"
                height="1000"
                loading="eager"
                decoding="async"
              />
            </div>

            <div className="about__body">
              <span className="eyebrow">Conócenos</span>
              <h1 className="text-balance" style={{ marginTop: 'var(--space-3)' }}>{data.aboutus_title}</h1>
              {ReactHtmlParser(data.aboutus_body)}

              <ul className="venue__list" style={{ marginTop: 'var(--space-6)' }}>
                <li><IconPin /> {BUSINESS.address}</li>
                <li><IconClock /> {BUSINESS.hours}</li>
                <li><IconParking /> {BUSINESS.parking}</li>
              </ul>

              <div className="about__cta">
                <Link className="btn btn--primary" to={ROUTES.agendar}>
                  Agendar mi cita <IconArrow />
                </Link>
                <Link className="btn btn--secondary" to={ROUTES.servicios}>
                  Ver nuestros servicios
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
